import * as z from "zod";

export const OTHER_OPTION = "Other";

/** Name rules shared by the onboarding account step and the AE-207 profile screen. */
export const userNameSchema = z
  .string()
  .min(2, "Name must contain at least 2 characters")
  .max(50, "Name must not exceed 50 characters")
  .refine((value) => value.trim().length >= 2, { message: "Name cannot consist only of spaces" });

export const accountSchema = z
  .object({
    user_name: userNameSchema,
    district_name: z.string().min(1, "Please select a district"),
    custom_district_name: z
      .string()
      .optional()
      .refine((value) => !value || value.trim().length >= 2, {
        message: "Custom district name cannot consist only of spaces",
      }),
    school_name: z.string().min(1, "Please select a school"),
    custom_school_name: z
      .string()
      .optional()
      .refine((value) => !value || value.trim().length >= 2, {
        message: "Custom school name cannot consist only of spaces",
      }),
  })
  .refine(
    (data) => {
      if (data.district_name === OTHER_OPTION) {
        return data.custom_district_name && data.custom_district_name.trim().length >= 2;
      }
      return true;
    },
    { message: "District name must contain at least 2 characters", path: ["custom_district_name"] }
  )
  .refine(
    (data) => {
      if (data.district_name === OTHER_OPTION) {
        return !data.custom_district_name || data.custom_district_name.length <= 100;
      }
      return true;
    },
    { message: "District name must not exceed 100 characters", path: ["custom_district_name"] }
  )
  .refine(
    (data) => {
      if (data.school_name === OTHER_OPTION) {
        return data.custom_school_name && data.custom_school_name.trim().length >= 2;
      }
      return true;
    },
    { message: "School name must contain at least 2 characters", path: ["custom_school_name"] }
  )
  .refine(
    (data) => {
      if (data.school_name === OTHER_OPTION) {
        return !data.custom_school_name || data.custom_school_name.length <= 100;
      }
      return true;
    },
    { message: "School name must not exceed 100 characters", path: ["custom_school_name"] }
  );

export type AccountForm = z.infer<typeof accountSchema>;
